import React, { useEffect, useState } from 'react'
import { FeatureImage } from 'js/components/FeatureImage'
import { lpImages } from 'js/pages/LandingPages/imageSources'
import { useMediaQuery } from 'js/pages/LandingPages/hooks/useMediaQuery'

const QrCode = () => {
  const [isOpen, setIsOpen] = useState(false)
  const isDesktop = useMediaQuery('(min-width: 1000px)')

  useEffect(() => {
    const hideQrCode = window.localStorage.getItem('hideQrCode')

    if (hideQrCode) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }, [])
  const handleClose = () => {
    setIsOpen(false)
    window.localStorage.setItem('hideQrCode', 'true')
  }

  if (!isOpen || !isDesktop) {
    return null
  }

  return (
    <div className="fixed bottom-[40%] right-[40px] z-10 rounded-4 bg-white-light p-18 ">
      <div className="relative text-center">
        <button
          onClick={handleClose}
          className="absolute right-[-16px] top-[-16px] cursor-pointer"
        >
          <FeatureImage image={lpImages.closeIcon} />
        </button>
        <FeatureImage
          image={lpImages.qrCode}
          className="mx-auto mt-10 h-[100px] w-[100px]"
        />
        <h3 className="pt-16 text-center text-14 uppercase">
          Download the app
        </h3>
      </div>
    </div>
  )
}

export default QrCode
